<div class="digitInput" #digitInput (keydown.enter)="confirmInput()">
  @for (digit of digits; track digit; let digitIndex = $index) {
    <pp-digit
      [ppDigit]="digit"
      [ppIndex]="digitIndex"
      [ppShowingError]="ppShowingError"
      (ppDigitChange)="onDigitChange($event, digitIndex)"
    ></pp-digit>
  }
</div>
